const config = {
  Api_Url: "https://ted.asiaseiraras.ir/api",
  baseImageUrl: "https://ted.asiaseiraras.ir/uploads",
  // Api_Url: "https://localhost:7276/api",
  // baseImageUrl: "https://localhost:7276/uploads",
};

export default config;
